<template>
  <Header class="header">
    <div class="container header-content">
      <div class="logo">
        <img src="@/assets/img/logo.png">
        <div>兼职直聘</div>
      </div>

      <a
        class="menuhome" @click="onMenuChange(menus[0])">
        首页
      </a>

      <a
        class="menuspecial"
        target="_blank" :href="util.getJzzpH5Url()">
        我要找兼职
      </a>
      <a
        class="menuitem"
        @click="emitScrollEvent">
        联系我们
      </a>
      <div class="header-actions">
        <a class="topBtn"
           target="_blank" :href="util.getDownloadAppUrl()">
          下载APP
        </a>
        <div class="topBtn" v-show="isShowLogin()" @click="login()">商家登录</div>
      </div>
      <CenterDialog
        :visible.sync="show"
        type="image"
        width="240px"
        title="请长按识别前往小程序继续操作"
        :image="imageQrcode"
        :showActions="false"
      />
    </div>
  </Header>
</template>

<script>
import CenterDialog from '../views/toc/ShowImageDialog.vue'
import CustomMenu from "@/views/toc/CustomMenu.vue";
import store from "@/store";
import router from "@/router";

export default {
  components: {CustomMenu, CenterDialog},
  name: 'TheHeader',
  data() {
    return {
      show: false,
      current: 'HomeContent',
      imageQrcode: require('@/assets/img/qrcode_shangjia.jpg'),
      menus: [
        {name: 'HomeContent', label: '首页'},
        // { name: 'FindJobContent', label: '我要找兼职' },
      ]
    }
  },
  methods: {
    emitScrollEvent() {
      // 使用 $emit 触发一个名为 'scroll-to-bottom' 的事件
      this.$emit('scroll-to-bottom');
    },
    onMenuChange(item) {
      // 触发事件，将选中的组件名传给父组件
      this.$emit('change-section', item.name);
    },
    isShowLogin() {
      return !store.state.token;
    },
    login() {
      this.show = true;
      if(this.util.isInMobileWx()){
          return
      }
      if (store.state.token) {
        router.push('/hometoc')
      } else {
        router.push('/login')
      }
    }
  }
}
</script>

<style scoped>
/* 使用 .ivu-layout-header 无法设置为 fixed，所以我们用一个普通 div/header 标签 */
.header {
  height: 60px;
  background-color: rgba(255, 255, 255, 0.8);
  backdrop-filter: blur(10px);
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 1000;
  padding: 0; /* 重置 Layout.Header 的默认 padding */
}

.header-content {
  display: flex;
  align-items: center;
  height: 100%;
}

.logo {
  display: flex;
  align-items: center;
  font-size: 20px;
  font-weight: bold;
  color: black;
  flex-shrink: 0;
  margin-left: 13%;
}

.logo img {
  height: 32px;
  margin-right: 10px;
  border-radius: 5px;
}

.header-actions {
  display: flex;
  margin-left: auto;
  gap: 15px;
}

.topBtn {
  height: 34px;
  line-height: 34px;
  font-size: 14px;
  background: white;
  border-radius: 10px;
  padding: 0 15px;
  color: black;
}

.menuitem {
  color: #333333;
  font-size: 16px;
  margin-left: 3%;
  flex-shrink: 0;
}

.menuspecial {
  color: #333333;
  font-size: 16px;
  margin-left: 3%;
  flex-shrink: 0;
}

.menuhome {
  color: #ff9900;
  font-size: 16px;
  margin-left: 10%;
  flex-shrink: 0;
}

@media screen and (max-width: 768px) {
  .logo {
    margin-left: 2%; /* 靠边站，给内容留空间 */
    font-size: 14px;
  }

  .menuitem {
    font-size: 14px;
    margin-left: 10px;
  }

  .menuhome {
    font-size: 14px;
    margin-left: 10px;
  }

  .topBtn {
    height: 24px;
    line-height: 24px;
    font-size: 12px;
    border-radius: 5px;
    padding: 0 8px;
  }

  .header-actions {
    margin-right: 10px;
    gap: 7px;
  }

  .menuspecial {
    display: none;
  }
}

</style>
